import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

// Social Media Icons
const FacebookIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const LinkedInIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const YouTubeIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const WhatsAppIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: FacebookIcon, label: 'Facebook', href: 'https://www.facebook.com/ActionFraudOne' },
    { icon: InstagramIcon, label: 'Instagram', href: 'https://www.instagram.com/actionfraudone' },
    { icon: LinkedInIcon, label: 'LinkedIn', href: 'https://www.linkedin.com/company/actionfraudone' },
    { icon: TikTokIcon, label: 'TikTok', href: 'https://www.tiktok.com/@actionfraudone' },
    { icon: YouTubeIcon, label: 'YouTube', href: 'https://www.youtube.com/@actionfraudone' },
  ];

  const quickLinks = [
    { label: 'Home', href: '/' },
    { label: 'Scam Check', href: '/scam-check' },
    { label: 'Investigations', href: '/investigations' },
    { label: 'Fraud Database', href: '/scam-database' },
    { label: 'Guides', href: '/scam-library' },
    { label: 'Case Studies', href: '/case-studies' },
    { label: 'About Us', href: '/about' },
    { label: 'Contact', href: '/contact' },
  ];

  const usefulResources = [
    { label: 'Report Fraud', href: 'https://www.actionfraud.police.uk/', external: true },
    { label: 'FCA ScamSmart', href: 'https://www.fca.org.uk/scamsmart', external: true },
    { label: 'Citizens Advice', href: 'https://www.citizensadvice.org.uk/consumer/scams/scams/', external: true },
    { label: 'Scam Library', href: '/scam-library' },
    { label: 'Report a Scam', href: '/report-a-scam' },
  ];

  return (
    <footer className="bg-[hsl(222,47%,5%)] border-t border-blue-500/20 mt-auto">
      {/* Footer Logo Scan Animation Styles */}
      <style>{`
        .footer-logo-scan-container {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          border-radius: 4px;
        }
        
        .footer-logo-scan-line {
          position: absolute;
          top: 0;
          left: -100%;
          width: 40%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(34, 211, 238, 0) 20%,
            rgba(34, 211, 238, 0.15) 40%,
            rgba(103, 232, 249, 0.3) 50%,
            rgba(34, 211, 238, 0.15) 60%,
            rgba(34, 211, 238, 0) 80%,
            transparent 100%
          );
          animation: footerLogoScan 3s ease-in-out infinite;
          animation-delay: 2s;
          pointer-events: none;
          z-index: 20;
        }
        
        @keyframes footerLogoScan {
          0% {
            left: -40%;
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          90% {
            opacity: 1;
          }
          100% {
            left: 100%;
            opacity: 0;
          }
        }
        
        .footer-logo-scan-container:hover .footer-logo-scan-line {
          animation-duration: 1.5s;
        }
      `}</style>
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1 - About */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="logo-shine-container relative">
                {/* Subtle blue glow behind logo */}
                <div className="absolute inset-0 bg-blue-500/15 blur-2xl rounded-full scale-125 opacity-60" />
                <img
                  src="/actionfraudone-logo-transparent.png"
                  alt="ActionFraudOne"
                  className="h-12 w-auto relative z-10 logo-premium-glow logo-transparent"
                />
              </div>
            </Link>
            <p className="text-base font-bold mb-2">
              <span className="text-white">Action</span>
              <span className="text-[#3b82f6] footer-brand-text">FraudOne</span>
              <sup className="text-[0.5em] text-blue-300/75 ml-0.5 font-normal">™</sup>
            </p>
            <p className="text-gray-400 text-sm mb-1">Verify. Protect. Take Action.</p>
            <p className="text-gray-400 text-sm mb-4">
              Fraud intelligence platform providing scam verification, entity checks, 
              and professional investigation services.
            </p>
            <div className="flex items-center gap-2">
              <p className="text-gray-400 text-xs uppercase tracking-widest font-semibold mb-2">Follow ActionFraudOne</p>
            </div>
            <p className="text-gray-500 text-xs leading-relaxed mb-3">
              Stay updated with fraud alerts, scam investigations, consumer protection guidance, scam prevention tips and case studies.
            </p>
            <div className="flex items-center gap-2">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-9 h-9 bg-blue-500/10 border border-blue-500/20 rounded-lg flex items-center justify-center text-gray-400 transition-all duration-300 ease-out hover:text-blue-400 hover:bg-blue-500/20 hover:border-blue-400/50 hover:shadow-[0_0_12px_rgba(59,130,246,0.3)] hover:scale-105"
                  data-testid={`footer-social-${social.label.toLowerCase()}`}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.href} 
                    className="text-gray-400 hover:text-blue-400 text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Useful Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Useful Resources</h3>
            <ul className="space-y-2">
              {usefulResources.map((link, index) => (
                <li key={index}>
                  {link.external ? (
                    <a 
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-blue-400 text-sm transition-colors flex items-center gap-1"
                    >
                      {link.label}
                      <ExternalLink className="w-3 h-3" />
                    </a>
                  ) : (
                    <Link 
                      to={link.href} 
                      className="text-gray-400 hover:text-blue-400 text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="mailto:info@actionfraudone.com" 
                  className="flex items-center gap-3 text-gray-400 hover:text-blue-400 text-sm transition-colors"
                >
                  <Mail className="w-4 h-4 text-blue-500" />
                  info@actionfraudone.com
                </a>
              </li>
              <li>
                <a 
                  href="tel:+447386668966" 
                  className="flex items-center gap-3 text-gray-400 hover:text-blue-400 text-sm transition-colors"
                >
                  <Phone className="w-4 h-4 text-blue-500" />
                  +44 7386 668966
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/447386668966"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-green-500/10 hover:bg-green-500/20 border border-green-500/30 rounded-lg text-green-500 text-sm transition-colors"
                >
                  <WhatsAppIcon size={16} />
                  WhatsApp Us
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" />
                <span>
                  167-169 Great Portland Street<br />
                  5th Floor, London W1W 5PF
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-blue-500/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            {/* Company Info & Disclaimer */}
            <div className="text-center lg:text-left max-w-2xl">
              <p className="text-gray-400 text-xs leading-relaxed mb-2">
                ActionFraudOne Ltd is a registered company. We provide fraud investigation and consultancy services.
                We are not a law firm and do not provide regulated legal advice.
              </p>
              <p className="text-blue-400/80 text-xs font-medium mb-2">
                Trusted by clients across the UK for fraud detection and recovery support.
              </p>
              <p className="text-gray-500 text-xs">
                © {currentYear} ActionFraudOne Ltd. All rights reserved.
              </p>
            </div>
            
            {/* Legal Links - Clean horizontal row */}
            <div className="flex items-center justify-center gap-6 text-xs whitespace-nowrap">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-blue-400 transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-blue-400 transition-colors">
                Terms of Service
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/legal-compliance" className="text-gray-400 hover:text-blue-400 transition-colors">
                Legal Compliance
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
